import React from 'react';
import classNames from 'classnames';
import SparklesIcon from 'icons/Sparkles.icon';
import { Button } from 'ncoded-component-library';
import { Trans, useTranslation } from 'react-i18next';
import { getIsNotNewFeature } from 'utils';

import './DiscoveryFeatureCard.styles.scss';
import './DiscoveryFeatureCard.styles.responsive.scss';

export type DiscoveryFeatureCardProps = {
  className?: string;
  createdAt?: Date | string;
  title: string;
  description: string;
  onUnderstood: () => void;
};

const DiscoveryFeatureCard: React.FC<DiscoveryFeatureCardProps> = (props) => {
  const { className, createdAt, title, description, onUnderstood } = props;

  const classes = classNames('discovery-feature-card', className);

  const { t } = useTranslation();

  if (getIsNotNewFeature(createdAt)) return null;

  return (
    <div className={classes}>
      <div className="discovery-feature-card__header">
        <div className="discovery-feature-card__icon-badge">
          <SparklesIcon />
        </div>

        <p className="discovery-feature-card__title">{title}</p>
      </div>

      <div className="discovery-feature-card__description">
        <Trans
          i18nKey={description}
          components={{
            b: <b />,
          }}
        />
      </div>

      <div className="discovery-feature-card__footer">
        <p>{t('tipForNewFeature')}</p>

        <Button onClick={onUnderstood}>{t('understood')}</Button>
      </div>
    </div>
  );
};

export default DiscoveryFeatureCard;
